import { getCountries } from "../api/apimethods";
import { ICodeMasterModel } from "../typings/models/CodeMasterModel";
import { IcountryOptions } from "../typings/models/CountryOption";

let countryOptions: IcountryOptions[] = [];

const fetchCountryOptions = async () => {
  try {
    const response = await getCountries();
    // Process the response data and create the country options array
    return countryOptions = response.data.map((country: ICodeMasterModel) => ({
      value: country.id,
      label: country.name,
    }));
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};

// Create a promise to await the fetchCountryOptions function
//const countryOptionsPromise = fetchCountryOptions();

export default fetchCountryOptions;



